import { Directive, EventEmitter, OnDestroy, Output, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';

@Directive()
export abstract class BasePopupComponent implements OnDestroy {
  @Output() CloseEventEmitter: EventEmitter<any> = new EventEmitter();
  @Output() ActionEventEmitter: EventEmitter<any> = new EventEmitter();
  protected destroy$ = new Subject<void>();

  constructor() { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    
  }

  setData(key: string, value: any) {

  }
}
